module.exports = __webpack_public_path__ + "static/media/Barcaldine.94164e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Barcaldine.png
// module id = 599
// module chunks = 0